module.exports = __webpack_public_path__ + "img/9.4b2ee005.png";